module.exports = __webpack_public_path__ + "static/media/friday2.13c1d243.jpg";